import router from '@/router'
import store from '@/store'
import analytics from '@/store/modules/analytics'
import user from '@/store/modules/user'
import { isMatchedByCoin } from '@/utils/helpers'

export const openRouteInNewWindow = (route) => {
  const { href } = router.resolve(route)
  window.open(href, '_blank')
}

export const goToEntity = id => {
if (!id || !user.getters.hasEntityAccess(user.state)) return
  const routeData = router.resolve({
    name: `view-entity-explorer`,
    params: { entityId: id },
  })

  window.open(routeData.href, '_blank')
}

export const goMailto = link => {
  if (!link) return
  window.location.href = `mailto:${link}`
}

export const goToAnalyticsByCoinKey = ({ val, type, coinKey, essential }) => {
  if (!isMatchedByCoin(store.getters['analytics/allCurrencyList'], val, coinKey, type)) {
    return;
  }

  const { href } = router.resolve({
    name: 'analytics',
    query: {
      [type]: val,
      type: coinKey,
      essential: essential ?? Boolean(analytics.state?.coinData.essential),
    },
  });

  window.open(href, '_blank');
}

export const goToAlerts = ({ from, to, coin, risk }) => {
  const query = {
    activeTab: 'inbox',
    ai_sort: false,
    dateRange_from: Math.floor(new Date(from).getTime() / 1000),
    dateRange_to: Math.floor(new Date(to).getTime() / 1000),
  }

  if (coin && coin !== 'all') {
    query.coin = coin
  }

  if (risk) {
    query.priorityList = risk
  }

  openRouteInNewWindow({
    name: 'alerts',
    query,
  })
}

export const goToAddressScoringLogs = ({ from, to, coin, risk }) => {
  openRouteInNewWindow({
    path: '/api-requests',
    query: {
      activeTab: 'addressScoring',
      ...(coin && coin !== 'all' && { ticker: coin }),
      start: new Date(from).getTime(),
      end: new Date(to).getTime(),
      ...(risk && { risk }),
    },
  })
}

export const goToTxScoringLogs = ({ from, to, coin, risk }) => {
  openRouteInNewWindow({
    path: '/api-requests',
    query: {
      activeTab: 'transactionScoring',
      ...(coin && coin !== 'all' && { ticker: coin }),
      start: new Date(from).getTime(),
      end: new Date(to).getTime(),
      ...(risk && { risk }),
    },
  })
}
